import axios from '../../../../libs/axios'

export function getListGlobalTradeData(year, flow){
  return axios.get(`/get/historical-trade/${flow}/KHM/WLD?year=${year}&sort=val&limit=10`)
}

export function getHSCodeDescription(hs){
  return axios.get(`/get/hs/search?hs=${hs}&v=H4`)
}

export function getListEconomies(){
  return axios.get(`/get/economies`)
}

export function getListTradePartnerByCommodityGroup(params){
  const {rep, tradeflow, year, product_group, hs_ver='H5'} = params
  return axios.get(`/wef/trade-partner?reporter=${rep}&tradeflow=${tradeflow}&product_group=${product_group}&year=${year}&hs_ver=${hs_ver}`)
}

export function getListTradePartnerByCommodity(params){
  const {rep, tradeflow, year, product_group, hs, hs_ver='H5'} = params
  const query = [
    `reporter=${rep}`,
    tradeflow && `tradeflow=${tradeflow}`,
    product_group && `product_group=${product_group}`,
    hs && `hs=${hs}`,
    `year=${year}`,
    `hs_ver=${hs_ver}`
  ].filter(Boolean).join('&');
  return axios.get(`/wef/trade-partner?${query}`)
}

export function getHistoricalTradeData(params){
  const {rep, par, tradeflow, productGroup} = params
  const query = [
    `reporter=${rep}`,
    tradeflow && `tradeflow=${tradeflow}`,
    productGroup && `product_group=${productGroup}`,
    par && `partner=${par}`
  ].filter(Boolean).join('&');

  return axios.get(`/wef/historical-trade?${query}`)
}

export function getCommodities(params){
  const {rep, par='WLD', tradeflow, hsDigits=6, year, productGroup=1, hsVer='H5'} = params
  return axios.get(`/wef/commodity-list?reporter=${rep}&tradeflow=${tradeflow}&partner=${par}&hs_digits=${hsDigits}&year=${year}&product_group=${productGroup}&hs_ver=${hsVer}`)
}

export function getProductGroups(params){
  const {type} = params
  return axios.get(`/get/hs/category/list?type=${type}`)
}
